import { useSelector } from 'react-redux';

import { storeInfoSelector } from './selectors';

export function useGetStoreInfo() {
  return useSelector(storeInfoSelector);
}
